const editorEs = {
	_lang: 'es',
	common: {
		cancel: 'Cancelar',
		insert: 'Insertar',
		apply: 'Aplicar',
		close: 'Cerrar',
		delete: 'Eliminar',
		update: 'Actualizar',
		save: 'Guardar',
		retry: 'Reintentar',
		send: 'Enviar',
		edit: 'Editar',
		comment: 'Comentario',
		reply: 'Responder',
		accept: 'Aceptar',
		reject: 'Rechazar',
		dismiss: 'Descartar',
		change: 'Cambiar',
		clear: 'Limpiar',
		px: 'px',
		closeDialog: 'Cerrar diálogo',
	},
	toolbar: {
		ariaLabel: 'Barra de herramientas de formato',
		file: 'Archivo',
		format: 'Formato',
		insert: 'Insertar',
		open: 'Abrir',
		openShortcut: 'Ctrl+O',
		save: 'Guardar',
		saveShortcut: 'Ctrl+S',
		print: 'Imprimir',
		printShortcut: 'Ctrl+P',
		pageSetup: 'Configurar página',
		leftToRight: 'Texto de izquierda a derecha',
		rightToLeft: 'Texto de derecha a izquierda',
		image: 'Imagen',
		table: 'Tabla',
		pageBreak: 'Salto de página',
		tableOfContents: 'Tabla de contenido',
		symbol: 'Símbolo',
		watermark: 'Marca de agua',
		help: 'Ayuda',
		reportIssue: 'Reportar problema',
	},
	formattingBar: {
		groups: {
			history: 'Historial',
			zoom: 'Zoom',
			styles: 'Estilos',
			font: 'Fuente',
			textFormatting: 'Formato de texto',
			script: 'Script',
			alignment: 'Alineación',
			listFormatting: 'Formato de lista',
			image: 'Imagen',
			table: 'Tabla',
		},
		undo: 'Deshacer',
		undoShortcut: 'Deshacer (Ctrl+Z)',
		redo: 'Rehacer',
		redoShortcut: 'Rehacer (Ctrl+Y)',
		bold: 'Negrita',
		boldShortcut: 'Negrita (Ctrl+B)',
		italic: 'Cursiva',
		italicShortcut: 'Cursiva (Ctrl+I)',
		underline: 'Subrayado',
		underlineShortcut: 'Subrayado (Ctrl+U)',
		strikethrough: 'Tachado',
		fontColor: 'Color de fuente',
		highlightColor: 'Color de resaltado',
		insertLink: 'Insertar enlace',
		insertLinkShortcut: 'Insertar enlace (Ctrl+K)',
		superscript: 'Superíndice',
		superscriptShortcut: 'Superíndice (Ctrl+Shift+=)',
		subscript: 'Subíndice',
		subscriptShortcut: 'Subíndice (Ctrl+=)',
		imageProperties: 'Propiedades de imagen',
		imagePropertiesShortcut: 'Propiedades de imagen (texto alternativo, borde)...',
		clearFormatting: 'Borrar formato',
	},
	alignment: {
		alignLeft: 'Alinear a la izquierda',
		alignLeftShortcut: 'Ctrl+L',
		center: 'Centrar',
		centerShortcut: 'Ctrl+E',
		alignRight: 'Alinear a la derecha',
		alignRightShortcut: 'Ctrl+R',
		justify: 'Justificar',
		justifyShortcut: 'Ctrl+J',
	},
	lists: {
		ariaLabel: 'Formato de lista',
		typeAriaLabel: 'Tipo de lista',
		indentationAriaLabel: 'Sangría de lista',
		bulletList: 'Lista con viñetas',
		numberedList: 'Lista numerada',
		decreaseIndent: 'Disminuir sangría',
		increaseIndent: 'Aumentar sangría',
	},
	lineSpacing: {
		single: 'Sencillo',
		double: 'Doble',
		lineSpacingTitle: 'Interlineado: {label}',
		paragraphSpacing: 'Espaciado de párrafo',
	},
	styles: {
		selectAriaLabel: 'Seleccionar estilo de párrafo',
		normalText: 'Texto normal',
		title: 'Título',
		subtitle: 'Subtítulo',
		heading1: 'Encabezado 1',
		heading2: 'Encabezado 2',
		heading3: 'Encabezado 3',
	},
	font: {
		selectAriaLabel: 'Seleccionar tipo de fuente',
		sansSerif: 'Sans Serif',
		serif: 'Serif',
		monospace: 'Monoespaciada',
	},
	fontSize: {
		decrease: 'Disminuir tamaño de fuente',
		increase: 'Aumentar tamaño de fuente',
		label: 'Tamaño de fuente',
		listLabel: 'Tamaños de fuente',
	},
	zoom: {
		ariaLabel: 'Zoom: {label}',
	},
	dialogs: {
		findReplace: {
			titleFind: 'Buscar',
			titleFindReplace: 'Buscar y reemplazar',
			findLabel: 'Buscar:',
			findPlaceholder: 'Ingrese el texto a buscar...',
			findAriaLabel: 'Buscar texto',
			findPrevious: 'Anterior',
			findPreviousTitle: 'Anterior (Shift+Enter)',
			findNext: 'Siguiente',
			findNextTitle: 'Siguiente (Enter)',
			matchCount: '{current} de {total} coincidencias',
			noResults: 'Sin resultados',
			replaceLabel: 'Reemplazar:',
			replacePlaceholder: 'Ingrese el texto de reemplazo...',
			replaceAriaLabel: 'Reemplazar texto',
			replaceButton: 'Reemplazar',
			replaceCurrentTitle: 'Reemplazar coincidencia actual',
			replaceAllButton: 'Reemplazar todo',
			replaceAllTitle: 'Reemplazar todas las coincidencias',
			matchCase: 'Distinguir mayúsculas',
			wholeWords: 'Palabras completas',
			matchesFound: '{total} coincidencias',
			toggleReplace: '+ Reemplazar',
		},
		hyperlink: {
			titleEdit: 'Editar hipervínculo',
			titleInsert: 'Insertar hipervínculo',
			tabWebAddress: 'Dirección web',
			tabBookmark: 'Marcador',
			urlLabel: 'URL',
			urlPlaceholder: 'https://ejemplo.com',
			urlHint: 'Ingrese una URL, correo (mailto:) o teléfono (tel:)',
			bookmarkLabel: 'Marcador',
			bookmarkPlaceholder: 'Seleccionar un marcador...',
			displayTextLabel: 'Texto a mostrar',
			displayTextPlaceholder: 'Texto a mostrar (opcional)',
			displayTextHint: 'Deje vacío para usar el texto seleccionado',
			tooltipLabel: 'Información (opcional)',
			tooltipPlaceholder: 'Texto al pasar el cursor',
			removeLink: 'Eliminar enlace',
			invalidUrl: 'Ingrese una URL válida',
			urlRequired: 'La URL es requerida',
		},
		insertTable: {
			title: 'Insertar tabla',
			hoverToSelect: 'Pase el cursor para seleccionar el tamaño',
			tableSize: 'Tabla {cols} x {rows}',
			orSpecifySize: 'o especificar tamaño',
			rowsLabel: 'Filas:',
			columnsLabel: 'Columnas:',
			insertButton: 'Insertar tabla',
			sizeSelector: 'Selector de tamaño de tabla',
			columnWidthLabel: 'Ancho de columna',
			fixedWidth: 'Fijo',
			autofit: 'Ajustar al contenido',
			tableStyleLabel: 'Estilo de tabla',
			validationHint: 'Filas: {minRows}-{maxRows}, Columnas: {minCols}-{maxCols}',
		},
		watermark: {
			title: 'Marca de agua',
			noWatermark: 'Sin marca de agua',
			picture: 'Marca de agua de imagen',
			text: 'Marca de agua de texto',
			selectPicture: 'Seleccionar imagen...',
			scale: 'Escala',
			washout: 'Desvanecer',
			textLabel: 'Texto',
			fontLabel: 'Fuente',
			sizeLabel: 'Tamaño',
			sizeAuto: 'Automático',
			colorLabel: 'Color',
			layoutLabel: 'Diseño',
			diagonal: 'Diagonal',
			horizontal: 'Horizontal',
			semitransparent: 'Semitransparente',
			presetLabel: 'Predefinido',
			applyButton: 'Aplicar',
			cancelButton: 'Cancelar',
		},
		splitCell: {
			title: 'Dividir celda',
			description: 'Establezca en cuántas filas y columnas dividir la celda seleccionada.',
			rowsLabel: 'Filas:',
			columnsLabel: 'Columnas:',
			currentMinimum: 'Mínimo del span actual: {rows} fila(s) x {cols} columna(s)',
			minValue: 'Use al menos {rows} fila(s) y {cols} columna(s).',
			notOneByOne: 'Elija al menos dos celdas resultantes.',
		},
		insertImage: {
			title: 'Insertar imagen',
			uploadAriaLabel: 'Haga clic o arrastre para subir una imagen',
			uploadText: 'Haga clic para seleccionar o arrastre una imagen',
			uploadSubtext: 'PNG, JPG, GIF hasta 10MB',
			dimensions: 'Dimensiones',
			widthLabel: 'Ancho:',
			heightLabel: 'Alto:',
			aspectRatioLocked: 'Proporción bloqueada',
			aspectRatioUnlocked: 'Proporción desbloqueada',
			altTextLabel: 'Texto alternativo (opcional)',
			altTextPlaceholder: 'Describa la imagen para accesibilidad',
			insertButton: 'Insertar imagen',
			invalidFile: 'Seleccione un archivo de imagen válido',
			fileTooLarge: 'El archivo es demasiado grande (máx. 10MB)',
			readFailed: 'Error al leer el archivo de imagen',
			loadFailed: 'Error al cargar la imagen',
			preview: 'Vista previa',
		},
		insertSymbol: {
			title: 'Insertar símbolo',
			searchPlaceholder: 'Buscar símbolos (carácter o Unicode)...',
			noResultsEmpty: 'No se encontraron símbolos',
			noResults: 'No se encontraron símbolos para "{query}"',
			decimal: 'Decimal: {value}',
			recent: 'Recientes:',
			categories: {
				common: 'Comunes',
				arrows: 'Flechas',
				math: 'Matemáticas',
				greek: 'Griego',
				shapes: 'Formas',
				punctuation: 'Puntuación',
				currency: 'Moneda',
				music: 'Música',
				emoji: 'Emoji',
			},
		},
		imageProperties: {
			title: 'Propiedades de imagen',
			altText: 'Texto alternativo',
			altTextPlaceholder: 'Describa esta imagen para accesibilidad...',
			border: 'Borde',
			width: 'Ancho',
			style: 'Estilo',
			color: 'Color',
			preview: 'Vista previa',
			textWrapping: 'Ajuste de texto',
			dimensions: 'Dimensiones',
			widthLabel: 'Ancho:',
			heightLabel: 'Alto:',
			lockAspectRatio: 'Bloquear proporción',
			wrapOptions: {
				inline: 'En línea con el texto',
				wrapRight: 'Ajuste de texto, flotante izquierda',
				wrapLeft: 'Ajuste de texto, flotante derecha',
				topAndBottom: 'Arriba y abajo',
				behind: 'Detrás del texto',
				inFront: 'Delante del texto',
			},
			borderStyles: {
				solid: 'Sólido',
				dashed: 'Discontinuo',
				dotted: 'Punteado',
				double: 'Doble',
				groove: 'Ranura',
				ridge: 'Cresta',
				inset: 'Hundido',
				outset: 'Realzado',
			},
		},
		pageSetup: {
			title: 'Configurar página',
			pageSize: 'TAMAÑO DE PÁGINA',
			sizeLabel: 'Tamaño',
			custom: 'Personalizado',
			orientation: 'Orientación',
			portrait: 'Vertical',
			landscape: 'Horizontal',
			margins: 'MÁRGENES',
			top: 'Superior',
			bottom: 'Inferior',
			left: 'Izquierdo',
			right: 'Derecho',
			pageSizes: {
				letter: 'Carta (8.5" × 11")',
				a4: 'A4 (8.27" × 11.69")',
				legal: 'Legal (8.5" × 14")',
				a3: 'A3 (11.69" × 16.54")',
				a5: 'A5 (5.83" × 8.27")',
				b5: 'B5 (6.93" × 9.84")',
				executive: 'Ejecutivo (7.25" × 10.5")',
			},
		},
		tableProperties: {
			title: 'Propiedades de tabla',
			widthType: 'Tipo de ancho',
			widthLabel: 'Ancho',
			alignmentLabel: 'Alineación',
			widthTypes: {
				auto: 'Automático',
				fixed: 'Fijo (twips)',
				percentage: 'Porcentaje',
			},
			units: {
				fiftiethsPercent: '(50avos de %)',
				twips: 'tw',
			},
			alignOptions: {
				left: 'Izquierda',
				center: 'Centro',
				right: 'Derecha',
			},
		},
		pasteSpecial: {
			title: 'Pegado especial',
			keepFormatting: 'Mantener formato de origen',
			keepFormattingDescription: 'Pegar con el formato original',
			keepFormattingShortcut: 'Ctrl+V',
			plainText: 'Pegar como texto sin formato',
			plainTextDescription: 'Pegar sin ningún formato',
			plainTextShortcut: 'Ctrl+Shift+V',
			readingClipboard: 'Leyendo portapapeles...',
			preview: 'Vista previa:',
			noContent: 'No hay contenido disponible para pegar',
			clipboardError: 'No se puede leer el portapapeles. Use Ctrl+V para pegar.',
		},
		keyboardShortcuts: {
			ariaLabel: 'Atajos de teclado',
			searchPlaceholder: 'Buscar atajos...',
			categories: {
				editing: 'Edición',
				formatting: 'Formato',
				navigation: 'Navegación',
				clipboard: 'Portapapeles',
				selection: 'Selección',
				view: 'Vista',
				file: 'Archivo',
				other: 'Otros',
			},
			noResults: 'No se encontraron atajos para "{query}"',
			pressEscToClose: 'Presione {key} para cerrar',
			or: 'o',
		},
	},
	contextMenu: {
		ariaLabel: 'Menú de acciones de IA',
		textMenuAriaLabel: 'Menú de edición de texto',
		customPromptPlaceholder: 'Ingrese un prompt personalizado...',
		cut: 'Cortar',
		cutShortcut: 'Ctrl+X',
		copy: 'Copiar',
		copyShortcut: 'Ctrl+C',
		paste: 'Pegar',
		pasteShortcut: 'Ctrl+V',
		pastePlainText: 'Pegar como texto sin formato',
		pastePlainTextShortcut: 'Ctrl+Shift+V',
		delete: 'Eliminar',
		deleteShortcut: 'Supr',
		selectAll: 'Seleccionar todo',
		selectAllShortcut: 'Ctrl+A',
		selected: 'Seleccionado:',
		aiActions: {
			askAi: 'Preguntar a la IA',
			rewrite: 'Reescribir',
			expand: 'Expandir',
			summarize: 'Resumir',
			translate: 'Traducir',
			explain: 'Explicar',
			fixGrammar: 'Corregir gramática',
			makeFormal: 'Hacer formal',
			makeCasual: 'Hacer informal',
			custom: 'Personalizado',
		},
	},
	titleBar: {
		untitled: 'Sin título',
		documentNameAriaLabel: 'Nombre del documento',
		menuBarAriaLabel: 'Barra de menú',
	},
	table: {
		insertRowAbove: 'Insertar fila arriba',
		insertRowBelow: 'Insertar fila abajo',
		insertColumnLeft: 'Insertar columna a la izquierda',
		insertColumnRight: 'Insertar columna a la derecha',
		deleteRow: 'Eliminar fila',
		deleteColumn: 'Eliminar columna',
		deleteTable: 'Eliminar tabla',
		mergeCells: 'Combinar celdas',
		splitCell: 'Dividir celda',
		editingTools: 'Herramientas de edición de tabla',
		label: 'Tabla:',
		cellFillColor: 'Color de relleno de celda',
		borderColor: 'Color de borde',
		borderWidth: 'Ancho de borde',
		unknownAction: 'Acción desconocida',
		borders: {
			all: 'Todos los bordes',
			outside: 'Bordes exteriores',
			inside: 'Bordes interiores',
			none: 'Sin bordes',
			remove: 'Eliminar bordes',
			top: 'Borde superior',
			bottom: 'Borde inferior',
			left: 'Borde izquierdo',
			right: 'Borde derecho',
			styleAriaLabel: 'Estilo de borde',
			tooltip: 'Bordes',
		},
		moreOptions: 'Más opciones de tabla',
		styles: {
			title: 'Estilos de tabla',
			label: 'Estilos',
			normalTable: 'Tabla normal',
			tableGrid: 'Cuadrícula de tabla',
			gridTableLight: 'Cuadrícula clara',
			plainTable1: 'Tabla simple 1',
			plainTable2: 'Tabla simple 2',
			plainTable3: 'Tabla simple 3',
			plainTable4: 'Tabla simple 4',
			gridTable1Light: 'Cuadrícula 1 clara',
			gridTable4Accent1: 'Cuadrícula 4 énfasis 1',
			gridTable5Dark: 'Cuadrícula 5 oscura',
			listTable3Accent2: 'Lista 3 énfasis 2',
			listTable4Accent3: 'Lista 4 énfasis 3',
			gridTable4Accent5: 'Cuadrícula 4 énfasis 5',
			gridTable4Accent6: 'Cuadrícula 4 énfasis 6',
		},
	},
	headerFooter: {
		header: 'Encabezado',
		footer: 'Pie de página',
		options: 'Opciones',
		insertPageNumber: 'Insertar número de página actual',
		insertTotalPages: 'Insertar total de páginas',
		remove: 'Eliminar {label}',
		closeEditing: 'Cerrar edición de {label}',
	},
	errors: {
		loadingDocument: 'Cargando documento...',
		noDocumentLoaded: 'No hay documento cargado',
		failedToLoad: 'Error al cargar el documento',
		unableToParse: 'No se puede leer el documento',
		somethingWentWrong: 'Algo salió mal',
		errorDescription: 'Ocurrió un error al renderizar este componente. Intente de nuevo o contacte soporte.',
		tryAgain: 'Intentar de nuevo',
		showDetails: 'Mostrar detalles',
		hideDetails: 'Ocultar detalles',
		unsavedChanges: 'Tiene cambios sin guardar. ¿Desea salir de todas formas?',
	},
	documentOutline: {
		ariaLabel: 'Esquema del documento',
		closeAriaLabel: 'Cerrar esquema',
		closeTitle: 'Cerrar esquema',
		title: 'Esquema',
		noHeadings: 'No se encontraron encabezados. Agregue encabezados al documento para verlos aquí.',
	},
	unsaved: {
		unsaved: 'Sin guardar',
		saved: 'Guardado',
		unsavedTitle: 'El documento tiene cambios sin guardar',
		savedTitle: 'Todos los cambios guardados',
		unsavedAriaLabel: 'Cambios sin guardar',
		savedAriaLabel: 'Todos los cambios guardados',
	},
	loading: {
		label: 'Cargando',
	},
	editor: {
		editing: 'Editando',
		editingDescription: 'Editar el documento directamente',
		suggesting: 'Sugiriendo',
		suggestingDescription: 'Las ediciones se convierten en sugerencias',
		viewing: 'Viendo',
		viewingDescription: 'Solo lectura, sin ediciones',
		failedToParse: 'Error al leer el documento',
		linkRemoved: 'Enlace eliminado',
		linkCopied: 'Enlace copiado al portapapeles',
		failedToSave: 'Error al guardar el documento',
		toggleCommentsSidebar: 'Alternar barra de comentarios',
		showDocumentOutline: 'Mostrar esquema del documento',
	},
	hyperlinkPopup: {
		displayTextPlaceholder: 'Texto a mostrar',
		urlPlaceholder: 'https://ejemplo.com',
		copyLink: 'Copiar enlace',
		editLink: 'Editar enlace',
		removeLink: 'Eliminar enlace',
	},
	print: {
		label: 'Imprimir',
		allPages: 'Todas ({totalPages} páginas)',
		singlePage: 'Página {start}',
		pageRange: 'Páginas {start}-{end}',
	},
};

export default editorEs;
